import React from 'react'

import { SvgProps } from '../types'
import { Icon } from '../Icon'

export const Play: React.FC<SvgProps> = (props) => {
  return (
    <Icon height="24" width="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M5.25 5.653C5.25 4.797 6.167 4.255 6.917 4.667L18.457 11.014C18.6336 11.111 18.781 11.2537 18.8836 11.4272C18.9862 11.6006 19.0403 11.7985 19.0403 12C19.0403 12.2015 18.9862 12.3994 18.8836 12.5728C18.781 12.7463 18.6336 12.889 18.457 12.986L6.917 19.333C6.74569 19.4272 6.55278 19.4751 6.35731 19.472C6.16184 19.469 5.97054 19.415 5.80227 19.3155C5.634 19.2159 5.49457 19.0743 5.39773 18.9045C5.30089 18.7346 5.24997 18.5425 5.25 18.347V5.653Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
